module.exports = {
	"pagination": {
		"GetResourceConfigHistory": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"limit_key": "limit",
			"result_key": "configurationItems"
		}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/aws-sdk/apis/config-2014-11-12.paginators.json
 ** module id = 1281
 ** module chunks = 0
 **/